<template>
  <div v-if="shouldShowTimeline" class="timeline-container">
    <el-popover
      style="max-height: 400px"
      placement="bottom"
      trigger="click"
      popper-class="timeline-popup"
    >
      <el-timeline reverse>
        <el-timeline-item
          v-for="(timeline, index) in timelineData"
          :key="chat.RowKey + '__' + index"
          :timestamp="timeline.timestamp"
          :color="timelineItemColor(timeline, index)"
        >
          {{ timeline.content }}
        </el-timeline-item>
      </el-timeline>
      <label slot="reference" class="el-tag el-tag--small el-tag--light">
        History
        <i class="el-icon-date el-icon--right"></i>
      </label>
    </el-popover>
  </div>
</template>

<script>
import { jsonParse } from "@/helpers/parser";
import _ from "lodash";
import moment from "moment";

export default {
  props: {
    chat: Object,
  },
  data() {
    return {
      showTimeline: true,
    };
  },
  methods: {
    timelineItemColor(timeline, index) {
      const defaultColor = "#5a5e66f";
      const activeColor = "#fa5555";

      if (!timeline.livechat) {
        return defaultColor;
      }

      if (
        timeline.livechat.RowKey === this.chat.RowKey &&
        timeline.livechat.PartitionKey === this.chat.PartitionKey
      ) {
        return activeColor;
      }

      return defaultColor;
    },
  },
  computed: {
    shouldShowTimeline() {
      return !_.isEmpty(this.timelineData);
    },
    timelineData() {
      const logs = _.get(this.chat, "stateVariables.userQueryTopic@@history");
      if (!logs) {
        return [];
      }
      return jsonParse(logs)
        .filter((it) => it?.meta?.livechat)
        .map((it) => ({
          timestamp: `${moment(it.ctime).format("DD/MM/yyyy, HH:mm")} (${moment(
            it.ctime
          ).fromNow()})`,
          content: it.value,
          livechat: it.meta?.livechat,
        }));
    },
  },
};
</script>

<style lang="scss">
.timeline-popup {
  max-height: 400px;
  overflow: auto;
  padding: 40px 0 10px 0 !important;
}
</style>
